import { User } from "@/shared/services/user.service";
import { TABLE_HEADERS } from "../users.constants";
import StatusBadge from "@/shared/components/ui/StatusBadge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/table";
import { Button } from "@/shared/components/ui/button";
import { Edit, Power } from "lucide-react";

interface UsersTableProps {
  users: User[];
  onEditUser: (user: User) => void;
  onDeleteUser: (user: User) => void;
  onActivateUser: (user: User) => void;
}

const UsersTable = ({
  users,
  onEditUser,
  onDeleteUser,
  onActivateUser,
}: UsersTableProps) => (
  <div className="overflow-auto max-h-[calc(100vh-350px)] border rounded-md">
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{TABLE_HEADERS.NAME}</TableHead>
          <TableHead>{TABLE_HEADERS.EMAIL}</TableHead>
          <TableHead>{TABLE_HEADERS.ROLE}</TableHead>
          <TableHead>{TABLE_HEADERS.STATUS}</TableHead>
          <TableHead>{TABLE_HEADERS.ORGANIZATION}</TableHead>
          <TableHead>{TABLE_HEADERS.CREATED_AT}</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>{user.name}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.role}</TableCell>
            <TableCell>
              <StatusBadge isActive={user.is_active} />
            </TableCell>
            <TableCell>{user.organization?.name || "-"}</TableCell>
            <TableCell>{user.created_at}</TableCell>
            <TableCell>
              <div className="flex space-x-2">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onEditUser(user)}
                  className="p-2"
                >
                  <Edit className="h-4 w-4" />
                </Button>
                {!user.is_active ? (
                  <Button
                    size="sm"
                    variant="outline"
                    className="p-2 text-green-500 hover:bg-green-500 hover:text-white"
                    onClick={() => onActivateUser(user)}
                    title="Activate user"
                  >
                    <Power className="h-4 w-4" />
                  </Button>
                ) : (
                  <Button
                    size="sm"
                    variant="outline"
                    className="p-2 text-red-500 hover:bg-red-500 hover:text-white"
                    onClick={() => onDeleteUser(user)}
                    title="Deactivate user"
                  >
                    <Power className="h-4 w-4" />
                  </Button>
                )}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export default UsersTable;
